import BundleExtraPricesCart from "@/components/modals/Bundle/BundleExtraPricesCart";
import BundleExtraProducts from "@/components/modals/Bundle/BundleExtraProducts";
import { useCart } from "@/context/cart";
import { handleAddItemsToCart } from "@/utils/product/addToCartFunc";
import { useState } from "react";
import Accordion from "./Accordion";
import BundleInstantSaving from "@/components/modals/Bundle/BundleInstantSaving";
import BundleAddTotalsToCart from "@/components/modals/Bundle/BundleAddTotalsToCart";
import BundleTitlePrice from "@/components/modals/Bundle/BundleTitlePrice";
import BundleAlbum from "@/components/modals/Bundle/BundleAlbum";
import { checkRequiredSegments, retainKeys } from "@/utils/product";
import { useClient } from "@/hooks/useClient";

const AddOnSavingsMobile = ({ parentProduct, t }) => {
  const bundles = parentProduct?.ulmod_bundles;
  const [bundleInView, setBundleInView] = useState(bundles?.at(0));
  const { isClient } = useClient();
  const [loading, setLoading] = useState(false);
  const [parentQty, setParentQty] = useState(1);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const parentInStock =
    parentProduct?.stock?.qty >= 0 || parentProduct?.stock?.is_in_stock == true;
  const { dispatch: dispatchCart } = useCart();
  const configurations =
    isClient &&
    Object.values(
      retainKeys(parentProduct?.selectedConfigurations, [
        "attribute_id",
        "option_id",
      ])
    );
  const bundleSKUs = [
    {
      sku:
        typeof parentProduct?.sku == "string"
          ? parentProduct?.sku
          : parentProduct?.sku?.at(0),
      qty: parentQty,
      ...(parentProduct?.type_id == "configurable" && {
        product_type: "configurable",
        product_option: {
          extension_attributes: {
            configurable_item_options: Object.values(
              retainKeys(parentProduct?.selectedConfigurations, [
                "attribute_id",
                "option_id",
              ])
            ),
          },
        },
      }),
    },
    ...selectedProducts?.map((p) => ({
      sku: typeof p.sku == "string" ? p?.sku : p?.sku?.at(0),
      qty: p?.qty,
    })),
  ];
  return (
    <div className="">
      <>
        <div className="flex justify-between items-center">
          <h1 className="text-2xl max-sm:text-lg font-bold">
            {t("Buy together and save")}
          </h1>
        </div>
        <div className="grid grid-cols-12 gap-6 my-4">
          <div className=" col-span-3 max-sm:order-2">
            <BundleAlbum {...{ parentProduct }} />
          </div>
          <div className="max-sm:col-span-7 max-sm:order-1 col-span-4">
            <BundleTitlePrice {...{ parentProduct, parentQty, setParentQty }} />
            <button
              onClick={() => {
                if (!checkRequiredSegments(bundles, selectedProducts)) {
                } else {
                  handleAddItemsToCart(
                    bundleSKUs,
                    setLoading,
                    dispatchCart,
                    configurations
                  );
                }
              }}
              disabled={!parentInStock}
              className={`flex-1 px-3 py-1 text-[11px] mt-2 hidden max-sm:flex rounded-md ${
                !parentInStock
                  ? "bg-gray-200 text-gray-600"
                  : "bg-primary text-white"
              } flex justify-center items-center w-full gap-2`}
            >
              {loading && <div className="loader w-6 text-white" />}
              <p>
                {parentInStock
                  ? t("Add to cart")
                  : t("Parent product is out of stock")}
              </p>
            </button>
          </div>
          <div className="max-sm:hidden col-span-5">
            <BundleAddTotalsToCart
              {...{
                selectedProducts,
                parentProduct,
                bundleSKUs,
                bundles,
                parentInStock,
                parentQty,
                t,
              }}
            />
          </div>
        </div>
        <div className="grid grid-cols-12 gap-6 max-sm:hidden">
          <div className="max-sm:col-span-full col-span-3">
            <BundleInstantSaving
              {...{ bundles, setBundleInView, bundleInView, t }}
            />
          </div>
          <div className="max-sm:col-span-full col-span-9 border rounded-md px-7 py-4">
            <h5 className="font-bold text-[17px] max-sm:text-sm">
              {bundleInView?.title}
            </h5>
            {/* <h6 className="text-[17px]">Limit 3 items below per bundle </h6> */}
            {bundleInView?.product_links?.map((product, i) => (
              <div key={i} className="grid grid-cols-12 mt-4 gap-7 max-sm:mt-8">
                <BundleExtraProducts key={i} {...{ product, t }} />
                <div className="max-sm:col-span-full col-span-6">
                  <BundleExtraPricesCart
                    {...{ product, selectedProducts, setSelectedProducts, t }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="grid-cols-12 gap-6 hidden max-sm:grid">
          {bundles?.map((bundle, i) => (
            <div key={i} className="col-span-12">
              <Accordion
                head={bundle?.title}
                key={i}
                body={bundle?.product_links?.map((product, i) => (
                  <div
                    key={i}
                    className="grid grid-cols-12 mt-4 gap-7 overflow-visible max-sm:mt-3 max-sm:gap-0"
                  >
                    <BundleExtraProducts
                      key={i}
                      {...{ product, selectedProducts, setSelectedProducts, t }}
                    />
                    <div className="max-sm:col-span-6 col-span-6">
                      <BundleExtraPricesCart
                        {...{
                          product,
                          selectedProducts,
                          setSelectedProducts,
                          t,
                        }}
                      />
                    </div>
                  </div>
                ))}
              />
            </div>
          ))}
          {/* <div className="max-sm:col-span-full col-span-3">
              <BundleInstantSaving
                {...{ bundles, setBundleInView, bundleInView, t }}
              />
            </div> */}
          {/* <div className="max-sm:col-span-full col-span-9 border rounded-md px-7 py-4">
              <h5 className="font-bold text-[17px] max-sm:text-sm">{bundleInView?.title}</h5>
              <h6 className="text-[17px]">Limit 3 items below per bundle </h6>
              {bundleInView?.product_links?.map((product, i) => (
                <div key={i} className="grid grid-cols-12 mt-4 gap-7 max-sm:mt-8">
                  <BundleExtraProducts key={i} {...{ product, t }} />
                  <div className="max-sm:col-span-full col-span-6">
                    <BundleExtraPricesCart
                      {...{ product, selectedProducts, setSelectedProducts, t }}
                    />
                  </div>
                </div>
              ))}
            </div> */}
        </div>
      </>
    </div>
  );
};

export default AddOnSavingsMobile;
